module.exports = __webpack_public_path__ + "img/black-folder-icon.d4dfe316.svg";